import { TourIndicatorColoredIcon } from '@carboncopyco/icons';
import type { Tour } from '@carboncopyco/types';
import { TooltipBubble } from '@carboncopyco/ui';
import { useCallback } from 'react';
import { SearchResultTile } from '../../../GridTiles';
import { useWorkspacePageProps } from '../WorkspacePageContext';
import { TourActionsDropdown } from './EntitiesActionsDropdown/TourActionsDropdown';

export const TourSearchResultTile = ({
  tour,
  archived,
  inFolder,
}: {
  tour: Tour;
  archived?: boolean;
  inFolder?: boolean;
}) => {
  const { goToTour } = useWorkspacePageProps();
  const DropdownAction = useCallback(
    ({ isMenuOpen, toggleMenu }) => {
      return (
        <TourActionsDropdown
          tour={tour}
          handleMenuOpen={toggleMenu}
          archived={archived}
          inFolder={inFolder}
        />
      );
    },
    [tour, archived, inFolder]
  );
  return (
    <SearchResultTile
      lastUpdated={tour.updateTime}
      title={tour.tourName}
      image={tour.image}
      totalShares={tour.totalShares}
      onTileClick={archived ? undefined : () => goToTour(tour.id)}
      ActionDropdown={DropdownAction}
      isOverlayTour={!tour.image}
      icon={
        <TooltipBubble
          placement="top"
          title="Tour"
        >
          <TourIndicatorColoredIcon size={18} />
        </TooltipBubble>
      }
    />
  );
};
